import type { WidgetConfig } from '@examdojo/core/widget';
import type { JSONContent } from '@tiptap/core';
import { v4 as uuid } from 'uuid';
import { ContentBlockType, WidgetBlock } from '../../model';
import { BlockToTiptapConverter } from '../blocks-to-tiptap.converter';

export const convertWidgetBlockToTiptap = ((block) => {
  return {
    type: 'widget',
    attrs: {
      ...(block.title && { title: block.title }),
      config: block.config,
    },
  };
}) satisfies BlockToTiptapConverter<WidgetBlock>;

export function convertTiptapToWidgetBlock(json: JSONContent): WidgetBlock {
  const attrs = json.attrs ?? {};

  return {
    id: uuid(),
    type: ContentBlockType.Widget,
    config: attrs['config'] as WidgetConfig,
    ...(attrs['title'] && { title: attrs['title'] as string }),
  };
}
